// =====================================================
// CENTRAL EXPORT — Design Token System
// Import everything from a single path:
//   import { brand, neutral, radius, shadows, getBrandThemeOverrides, T } from '../../theme';
// =====================================================

import {
  brand   as _brand,
  status  as _status,
  neutral as _neutral,
  surface as _surface,
  text    as _text,
} from './designTokens';
// Design Tokens
export {
  brand,
  status,
  actionButtons,
  neutral,
  surface,
  text,
  radius,
  shadows,
} from './designTokens';

// MUI Theme Bridge
export { getBrandThemeOverrides } from './muiThemeOverrides';

// ─── Shared "T" Adapter ────────────────────────────────────────
// Drop-in replacement for the per-file `const T = { ... }` objects.
// Every key that any component ever referenced is mapped here.

export const T = {
  // Brand / Primary
  primary:      _brand.main,
  primaryDark:  _brand.dark,
  primaryMid:   _brand.light,
  primaryBg:    _surface.cardBg, // Changed to white globally for search fields & cards
  primaryLight: _brand[100],

  // Surface
  white:        _surface.cardBg,

  // Borders
  border:       _surface.borderLight,
  borderHover:  _brand[200],

  // Text
  text:         _text.primary,
  textSub:      _text.secondary,
  textMuted:    _text.muted,

  // Red / Danger (same as brand since brand IS red)
  red:          _brand.main,
  redBg:        _brand[50],
  redBorder:    _brand[200],

  // Row colors
  baseRow:      _neutral[50],
  altRow:       _surface.cardBg,
  rowAlt:       _surface.cardBg,     // MainGrid variant
  rowHover:     _neutral[100],
  hoverRow:     _neutral[100],          // MainGrid variant

  // Header
  headerBg:     _neutral[50],
  headerText:   _neutral[700],

  // Status — Success
  success:       _status.success.dark,
  successBg:     _status.success.bg,
  successBorder: _status.success.border,

  // Status — Warning
  warning:       _status.warning.dark,
  warningBg:     _status.warning.bg,
  warningBorder: _status.warning.border,

  // Status — Info
  info:          _status.info.main,
  infoBg:        _status.info.bg,
  infoBorder:    _status.info.border,

  // Status — Error
  error:         _status.error.main,
  errorBg:       _status.error.bg,
  errorBorder:   _status.error.border,
};

// ─── Brand color string (for Form pages that use `const brand = "..."`) ──
export const brandColor = _brand.main;
